<template>
<div
    class="skill rectangle flex items-center justify-center lg:justify-start"
    :class="{ skill__locked: !trophy.unlocked }"
>
    <div class="content lg:flex lg:items-center"
    :class="{
        'text-center': trophy.icon === undefined
    }">
        <img :src="trophy.icon.url" alt="" class="lg:mr-2" v-if="trophy.icon !== undefined"/>
        <p v-html="trophy.text.replace(/\n/g, '<br />')" />
    </div>
</div>
</template>

<script>
export default {
    props: {
        trophy: {
            type: Object,
            required: true
        }
    }
}
</script>